import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {contarSumaWhere} from "../../Servicios/BD/Contadores/contarSumaWhere";

export const obtenerRendimientosBonosContrato = async (id) => {


    let totalBonos = 0
    let wBonos = [where('idContrato', '==',id), where('tipo', 'in', ['Bono', 'Rendimientos'])]
    let doxBonos = await contarSumaWhere({coleccion: 'movimientos', wheres: wBonos, propiedad: 'valor'})
    if (doxBonos.res){
        totalBonos = doxBonos.data
    }

    return totalBonos

}